import React, { useEffect, useState, useRef } from "react";
import LinearProgress from "@mui/joy/LinearProgress";
import { useCountUp } from "use-count-up";

function Skills(props) {
  const [isVisible, setIsVisible] = useState(false);
  const skillRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after it's visible
        }
      },
      { threshold: 0.1 } // Trigger when 30% of the component is visible
    );

    if (skillRef.current) {
      observer.observe(skillRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const { value } = useCountUp({
    isCounting: isVisible,
    duration: 0.5,
    easing: "linear",
    start: 0,
    end: props.value,
  });

  return (
    <div className="progress" ref={skillRef}>
      <span className="skill">
        <span>{props.title}</span> <i className="val">{Math.round(value)}%</i>
      </span>
      <div className="progress-bar-wrap">
        <LinearProgress
          determinate
          color="success"
          size="sm"
          thickness={10}
          value={isVisible ? Number(value) : 0} // Only animate when visible
          sx={{
            "--LinearProgress-radius": "0",
            color: "#18d26e",
            background: "color-mix(in srgb, #fafafa, transparent 90%)",
          }}
        />
      </div>
    </div>
  );
}

export default Skills;
